import { useState, useEffect } from 'react';
import {
  // IconSelected,
  // IconBlock,
  // IconAttention,
  IconTrash,
  IconLoader,
  PermissionEnum,
  Popup,
} from '@ui/src';
import { useAppSelector } from '@store';
import { DocumentStatus } from '../../hoc/bank-and-psp/types';
import {
  useLazyGetPspPartnerDocumentFileQuery,
  useDeletePspPartnerDocumentMutation,
  useLazyGetPspAccountDocumentFileQuery,
  useDeletePspAccountDocumentMutation,
} from '../../hoc/bank-and-psp/store/services';
import { DocumentItemTypes } from './types';

import cn from './info.module.css';

// const getDocumentStatusName = (status: DocumentStatus) => {
//   let statusName;

//   switch (status) {
//     case DocumentStatus.ACCEPTED:
//       statusName = 'Accepted';
//       break;
//     case DocumentStatus.EXPIRED:
//       statusName = 'Expired';
//       break;
//     case DocumentStatus.NEW:
//       statusName = 'New';
//       break;
//     case DocumentStatus.REJECTED:
//       statusName = 'Rejected';
//       break;
//     default:
//       statusName = status;
//       break;
//   }

//   return statusName;
// };

// const documentStatusIcon = (status: DocumentStatus) => {
//   let statusIcon;

//   switch (status) {
//     case DocumentStatus.ACCEPTED:
//       statusIcon = <IconSelected className={cn.documentStatusIconActive} />;
//       break;
//     case DocumentStatus.NEW:
//       statusIcon = <div className={cn.documentStatusNew} />;
//       break;
//     case DocumentStatus.EXPIRED:
//       statusIcon = <IconAttention className={cn.documentStatusIconExpired} />;
//       break;
//     case DocumentStatus.REJECTED:
//       statusIcon = <IconBlock className={cn.documentStatusIconDisabled} />;
//       break;
//     default:
//       break;
//   }

//   return statusIcon;
// };

const Document = ({
  document: documentItem,
  bankId,
  accountId,
  accountPage,
}: DocumentItemTypes) => {
  const [getDocumentFile] = useLazyGetPspPartnerDocumentFileQuery();
  const [getAccountDocumentFile] = useLazyGetPspAccountDocumentFileQuery();
  const [deleteDocument, { isLoading, isSuccess }] =
    useDeletePspPartnerDocumentMutation();
  const [
    deleteAccountDocument,
    { isLoading: deleteIsLoading, isSuccess: deleteIsSuccess },
  ] = useDeletePspAccountDocumentMutation();
  const [deletePopupVisible, setDeletePopupVisible] = useState(false);

  const { activePermissions } = useAppSelector(
    (state) => state.configurationDictionaries,
  );

  const getFile = async () => {
    let response;

    if (accountPage) {
      response = await getAccountDocumentFile({
        id: accountId as string,
        documentId: documentItem.id,
      });
    } else {
      response = await getDocumentFile({
        id: bankId as string,
        documentId: documentItem.id,
      });
    }

    if (response.data) {
      const hiddenElement = document.createElement('a');
      const url = window.URL || window.webkitURL;

      // @ts-ignore
      const blobPDF = url.createObjectURL(response.data);
      hiddenElement.href = blobPDF;
      hiddenElement.target = '_blank';
      hiddenElement.download = documentItem.name;
      hiddenElement.click();
    }
  };

  let deleteButtonVisible = false;

  if (
    (accountPage &&
      activePermissions?.includes(
        PermissionEnum.PSP_ACCOUNT_DOCUMENTS_DELETE_ACTION,
      )) ||
    (!accountPage &&
      activePermissions?.includes(PermissionEnum.PSP_DOCUMENTS_DELETE_ACTION))
  ) {
    deleteButtonVisible = true;
  }

  useEffect(() => {
    if (isSuccess || deleteIsSuccess) {
      setDeletePopupVisible(false);
    }
  }, [isSuccess, deleteIsSuccess]);

  return (
    <>
      <Popup
        title={`Delete ${documentItem?.name}`}
        onCancelClick={() => setDeletePopupVisible(false)}
        onOkClick={() =>
          accountPage
            ? deleteAccountDocument({
                id: accountId as string,
                documentId: documentItem.id,
              })
            : deleteDocument({
                id: bankId as string,
                documentId: documentItem.id,
              })
        }
        cancelButtonText="Cancel"
        okButtonText={isLoading || deleteIsLoading ? 'Loading...' : 'Delete'}
        isVisible={deletePopupVisible}
        isLoading={isLoading || deleteIsLoading}
      />
      <div className={cn.document}>
        <div className={cn.documentTitle}>
          <button type="button" className={cn.documentLink} onClick={getFile}>
            {documentItem.name}
          </button>
        </div>
        <div className={cn.documentStatusWrapper}>
          <div
            className={`
        ${cn.documentStatus}
        ${
          documentItem.status === DocumentStatus.ACCEPTED
            ? cn.documentStatusActive
            : ''
        }
        `}
          >
            {/* {documentStatusIcon(documentItem.status)}
          {getDocumentStatusName(documentItem.status)} */}
            {deleteButtonVisible && (
              <button
                type="button"
                className={cn.removeDocument}
                onClick={() => setDeletePopupVisible(true)}
              >
                {isLoading || deleteIsLoading ? (
                  <IconLoader width={20} height={20} />
                ) : (
                  <IconTrash />
                )}
              </button>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Document;
